import { useState, useMemo, useEffect } from "react";
import {
  focusElement,
  getTodayString,
  selectedOptic,
  userData,
} from "../js/utils";
import { useSuppliers } from "./useSuppliers";
import { useBrands } from "./useBrands";
import { post } from "../js/post";

export function useOrderBase({
  orderId,
  familia,
  structure,
  requiredFields,
  fieldsToFocus,
  saveEndpoint,
  getOrderEndpoint,
  onSave,
  createPopupQuestion,
  removePopupQuestion,
}) {
  const initialOrder = useMemo(
    () =>
      orderId === -1
        ? { ...structure, fechaPedido: getTodayString(), estado: "Pedido" }
        : structure,
    [orderId],
  );

  const [currentOrder, setCurrentOrder] = useState(initialOrder);
  const [currentOrderFixed, setCurrentOrderFixed] = useState(initialOrder);
  const [selectedSupplier, setSelectedSupplier] = useState({
    id: "",
    text: "",
  });
  const [searchCode, setSearchCode] = useState("");

  const [rawSupplierList] = useSuppliers(familia);
  const supplierList = useMemo(
    () => [
      { id: "", text: "" },
      ...rawSupplierList.map((e) => ({ id: e.id, text: e.nombre })),
    ],
    [rawSupplierList],
  );

  const [rawBrandList, refreshBrands] = useBrands(
    familia,
    selectedSupplier.id,
    "",
  );
  const brandList = useMemo(
    () => [
      { id: "", text: "" },
      ...rawBrandList.map((e) => ({ id: e, text: e })),
    ],
    [rawBrandList],
  );

  useEffect(() => {
    focusElement(50);
  }, []);

  useEffect(() => {
    setCurrentOrder((prev) => ({ ...prev, proveedor: selectedSupplier.id }));
    refreshBrands();
  }, [selectedSupplier]);

  useEffect(() => {
    if (currentOrder.proveedor && !selectedSupplier.id) {
      const supplier = supplierList.find(
        (s) => s.id === parseInt(currentOrder.proveedor),
      );
      if (supplier) setSelectedSupplier(supplier);
    }
  }, [supplierList, currentOrder.proveedor]);

  function validateOrder() {
    return requiredFields.every((field) => currentOrder[field] !== "");
  }

  function focusFields() {
    const emptyField = fieldsToFocus.find(
      ({ field }) => currentOrder[field] === "",
    );
    if (emptyField) focusElement(emptyField.elementId);
  }

  async function saveOrder() {
    const response = await post(saveEndpoint, {
      token: userData.token,
      idOptica: selectedOptic.id,
      ...currentOrder,
    });
    // console.log(
      // "GUARDANDO PEDIDO: ",
      // {
        // token: userData.token,
        // idOptica: selectedOptic.id,
        // ...currentOrder,
      // },
      // response,
    // );
    if (response.idPedido) {
      if (orderId === -1) {
        setCurrentOrder((prev) => ({ ...prev, idPedido: response.idPedido }));
        setCurrentOrderFixed((prev) => ({
          ...prev,
          ...currentOrder,
          idPedido: response.idPedido,
        }));
      } else {
        setCurrentOrderFixed((prev) => ({ ...prev, ...currentOrder }));
      }
      onSave();
      createPopupQuestion(
        "Pedido guardado con éxito.",
        async () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  }

  async function deleteOrder() {
    await post("support-extra/pedidos/EliminarPedidos.php", {
      token: userData.token,
      familia,
      pedidos: [currentOrder.idPedido],
    });
    // console.log("ELIMINANDO PEDIDO: ", {
      // token: userData.token,
      // familia,
      // pedidos: [currentOrder.idPedido],
    // });
  }

  async function getOrder() {
    const response = await post(getOrderEndpoint, {
      token: userData.token,
      idPedido: orderId,
    });
    // console.log(
      // "OBTENIENDO PEDIDO: ",
      // {
        // token: userData.token,
        // idPedido: orderId,
      // },
      // response,
    // );
    setSearchCode(response.codigo);
    const supplier = supplierList.find(
      (s) => s.id === parseInt(response.proveedor),
    );
    if (supplier) setSelectedSupplier(supplier);
    setCurrentOrder({ ...initialOrder, ...response });
    setCurrentOrderFixed({ ...initialOrder, ...response });
  }

  useEffect(() => {
    if (orderId !== -1) {
      getOrder();
    }
  }, [orderId]);

  return {
    initialOrder,
    currentOrder,
    setCurrentOrder,
    currentOrderFixed,
    setCurrentOrderFixed,
    selectedSupplier,
    setSelectedSupplier,
    searchCode,
    setSearchCode,
    supplierList,
    brandList,
    validateOrder,
    focusFields,
    saveOrder,
    deleteOrder,
  };
}
